export const BLOCK_TYPE_CONTAINER = 'container';
export const BLOCK_TYPE_CONTENT = 'content';